import React from 'react';
import { StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonSection,
  SkeletonList,
  SkeletonCard,
} from '@/components/common/skeleton';

export const ResourcesScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <SkeletonSection headerWidth={120}>
      <SkeletonList count={3} gap={12}>
        <SkeletonCard>
          <SkeletonBone width="70%" height={16} />
          <SkeletonBone width="50%" height={14} />
        </SkeletonCard>
      </SkeletonList>
    </SkeletonSection>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
});
